<div class="skill-area ptb-100 bg-fffdfd">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="skill-content">
          <div class="section-title">
            <h2>{{ 'skill.title' | translate }} <span>{{ 'skill.highlight' | translate }}</span></h2>
            <p>{{ 'skill.subtitle' | translate }}</p>
          </div>
          <div class="skills-list">
            <div class="skill-item">
              <div class="skill-header">
                <h4 class="skill-title">{{ 'skill.software' | translate }}</h4>
                <div class="skill-percentage">
                  <div class="count-box"><span class="count-text">95</span>%</div>
                </div>
              </div>
              <div class="skill-bar">
                <div class="bar-inner"><div class="bar progress-line" data-width="95"></div></div>
              </div>
            </div>
            <div class="skill-item">
              <div class="skill-header">
                <h4 class="skill-title">{{ 'skill.uiux' | translate }}</h4>
                <div class="skill-percentage"><div class="count-box"><span class="count-text">90</span>%</div></div>
              </div>
              <div class="skill-bar">
                <div class="bar-inner"><div class="bar progress-line" data-width="90"></div></div>
              </div>
            </div>
            <div class="skill-item">
              <div class="skill-header">
                <h4 class="skill-title">{{ 'skill.pm' | translate }}</h4>
                <div class="skill-percentage"><div class="count-box"><span class="count-text">92</span>%</div></div>
              </div>
              <div class="skill-bar">
                <div class="bar-inner"><div class="bar progress-line" data-width="92"></div></div>
              </div>
            </div>
            <div class="skill-item">
              <div class="skill-header">
                <h4 class="skill-title">{{ 'skill.applied' | translate }}</h4>
                <div class="skill-percentage"><div class="count-box"><span class="count-text">97</span>%</div></div>
              </div>
              <div class="skill-bar">
                <div class="bar-inner"><div class="bar progress-line" data-width="97"></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        @if (!isVideoPlaying) {
          <div class="skill-video">
            <img src="assets/images/screenshot_v2_pafar.png" [attr.alt]="'about.videoAlt' | translate">
            <div class="video-btn">
              <button class="popup-youtube" (click)="playVideo()">
                <i class="fas fa-play"></i>
              </button>
            </div>
          </div>
        }
        @if (isVideoPlaying) {
          <div class="video-container" style="position: relative;">
            <button class="close-video-btn" (click)="closeVideo()">
              <i class="fas fa-times"></i>
            </button>
            <iframe
              [src]="videoUrl"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
        }
      </div>
    </div>
  </div>
</div>
